import { images } from '../constants'; 

const museoData = [  
    {
        id: 1,
        image: images.museo1,
        title: "Muzeum",
        date: "",
        paragraphs: [
            "Drodzy Przyjaciele Zielonych Przestrzeni ",
            "Z ogromną radością i dumą informujemy, że w przyszłym roku, w zabytkowym zespole dworsko-parkowym w Imielnie, powstanie Muzeum Ogrodnictwa – miejsce poświęcone historii polskich ogrodów, sztuce ich tworzenia oraz pracy ludzi, którzy od pokoleń budują zielone dziedzictwo naszego kraju.",
            "Zwracamy się do Was z serdeczną prośbą o wsparcie w tworzeniu muzealnej kolekcji.",
            "Wierzymy, że wspólnie stworzymy wyjątkową przestrzeń, która pokaże dorobek wielu pokoleń ogrodników, projektantów i pasjonatów. Każdy eksponat otrzyma swoje miejsce i historię, a nazwiska darczyńców zostaną uhonorowane w muzealnej dokumentacji.",
            "Dziękujemy za wszelką pomoc, życzliwość i wsparcie.",
            "Razem pielęgnujemy pamięć o ogrodach.",
            "Prosimy o kontakt z fundacją w celu omówienia przekazania muzealnych eksponatów.",
            "Fundacja Dwór Imielno",
        ],
        agenda: {
            intro: "Jeśli posiadacie",
            points: [
                "stare narzędzia ogrodnicze,",
                "archiwalne zdjęcia ogrodów, szklarni, inspektów,",
                "dokumenty, katalogi roślin, dawne podręczniki i poradniki,",
                "elementy wyposażenia związane z ogrodnictwem,",
                "inne cenne pamiątki czy eksponaty,"
            ],
            end: "które mogłyby wzbogacić opowieść o historii polskiego ogrodnictwa, będziemy ogromnie wdzięczni za ich przekazanie."
        },
        gallery: [
            images.eksponat1,
            images.eksponat2,
            images.eksponat3,
            images.eksponat4,
            images.eksponat5,
            images.eksponat6,
            images.eksponat7,
            images.eksponat8,
        ]
    },
];

export default museoData;